import React, { useState } from "react";
import "./ChatbotTutorial.css";

function ChatbotTutorial() {
  const [open, setOpen] = useState(false);

  return (
    <div className="tutorial-wrapper">

      <button className="tutorial-toggle" onClick={() => setOpen(!open)}>
        🎓 REACH Web App Tutorial (REACH ব্যবহারের সম্পূর্ণ নির্দেশিকা)
      </button>

      {open && (
        <div className="tutorial-content">

          {/* ================= VIDEO SECTION ================= */}
          <div className="tutorial-card">
            <h3>🎥 Step 1: Watch the Full Video Guide (ভিডিও নির্দেশিকা)</h3>
            <a
              href="https://youtu.be/N29UNZgADbg"
              target="_blank"
              rel="noopener noreferrer"
              className="tutorial-link"
            >
              ▶ Watch Complete Tutorial on YouTube
            </a>
            <p>
              This video explains how to use REACH from login to health consultation.
              <br />
              (এই ভিডিওতে লগইন থেকে স্বাস্থ্য পরামর্শ পর্যন্ত সব ব্যাখ্যা করা হয়েছে।)
            </p>
          </div>

          {/* ================= COMPLETE GUIDE ================= */}
          <div className="tutorial-card">
            <h3>📜 Complete Step-by-Step Guide (ধাপে ধাপে ব্যবহারের নিয়ম)</h3>

            <ul className="tutorial-list">

              {/* STEP 1 */}
              <li>
                🔐 <strong>Step 1: Login / Register</strong><br/>
                • Click <b>Login</b> or <b>Register</b> in the top menu.<br/>
                • You may sign in using Google or normal email/password.<br/>
                • After login you are redirected to <b>/chat</b>.<br/>
                (উপরের মেনু থেকে লগইন বা নিবন্ধন করুন। লগইনের পর /chat পেজে নিয়ে যাবে।)
              </li>

              {/* STEP 2 */}
              <li>
                💬 <strong>Step 2: Welcome Screen</strong><br/>
                You will see two main options:<br/>
                🍎 Nutrition (পুষ্টি)<br/>
                🏥 Health Awareness (স্বাস্থ্য সচেতনতা)
              </li>

              {/* STEP 3 */}
              <li>
                🍎 <strong>If You Click "Nutrition"</strong><br/>
                The chatbot will ask step-by-step questions:<br/>
                • Age → Gender → Weight → Height → Activity Level → Diet Preference → Health Goal → Disease → Season<br/>
                • After completing all steps, AI generates a personalized 3-Day Meal Plan.<br/>
                • You can click 🔄 Regenerate to create a new meal plan.<br/>
                (প্রতিটি প্রশ্নের উত্তর দিলে ব্যক্তিগত খাদ্য পরিকল্পনা তৈরি হবে।)
              </li>

              {/* STEP 4 */}
              <li>
                🏥 <strong>If You Click "Health Awareness"</strong><br/>
                • AI initializes for 20 seconds (⏳ loading screen).<br/>
                • Then you can describe symptoms.<br/>
                • You may type in English, Bengali, or Assamese.<br/>
                • System auto-translates regional language before sending to AI.<br/>
                (বাংলা বা অসমীয়া লিখলেও সিস্টেম নিজে অনুবাদ করবে।)
              </li>

              {/* STEP 5 */}
              <li>
                🌐 <strong>Translate Button (🌐)</strong><br/>
                Converts chatbot response to Bengali.<br/>
                (বার্তাকে বাংলায় অনুবাদ করে।)
              </li>

              {/* STEP 6 */}
              <li>
                🔊 <strong>TTS (Text-to-Speech)</strong><br/>
                • 🔊 Reads message in English<br/>
                • 🔊(বাং) Reads in Bengali<br/>
                • TTS On / Off button toggles voice mode<br/>
                (ভয়েস পড়ে শোনাবে।)
              </li>

              {/* STEP 7 */}
              <li>
                ⏳ <strong>AI Loading Screen</strong><br/>
                Shows when Health AI is initializing.<br/>
                Displays progress bar and countdown.<br/>
                (AI প্রস্তুতির সময় অগ্রগতি দেখায়।)
              </li>

              {/* STEP 8 */}
              <li>
                📘 <strong>Nutrition Knowledge Library</strong><br/>
                Scroll below chatbot to access:<br/>
                • Vitamins Table<br/>
                • Minerals Table<br/>
                • Protein Sources<br/>
                • Balanced Diet by Age<br/>
                (পুষ্টি সংক্রান্ত শিক্ষামূলক তথ্য টেবিল।)
              </li>

              {/* STEP 9 */}
              <li>
                💾 <strong>Session Saving</strong><br/>
                • If logged in, chat is temporarily saved during session.<br/>
                • Refresh keeps chat history.<br/>
                • Logout clears session.<br/>
                (লগইন থাকলে রিফ্রেশ করলেও চ্যাট থাকবে।)
              </li>

              {/* STEP 10 */}
              <li>
                🧭 <strong>Navigation Tips</strong><br/>
                • Home – Landing page<br/>
                • About – Project info<br/>
                • Contact – Support<br/>
                • Chatbot – Direct chat access<br/>
              </li>

            </ul>

            <p className="tutorial-note">
              💡 <strong>Important Tip:</strong><br/>
              You can safely type symptoms in Bengali or Assamese.  
              AI processes English internally after translation.  
              (আপনি বাংলা বা অসমীয়া লিখলেও AI সঠিকভাবে বুঝবে।)
            </p>

          </div>

        </div>
      )}
    </div>
  );
}

export default ChatbotTutorial;
